import {csrf} from "~/lib/tools";

const baseUrl = (org_id, machine_id, id)  => `/dashboard/organizations/${org_id}/machine_incidents${id ? '/' + id.toString() :  ''}.json?machine_id=${machine_id}`;
const fetchIncidents = async (org_id, machine_id) => {
    return fetch(baseUrl(org_id, machine_id))
        .then(r => r.json());
}
export {fetchIncidents}